module.exports = __webpack_public_path__ + "static/img/7.f79e0e70.png";